"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOtherActionsControl = exports.TOOLBAR_OTHER_ACTIONS_CONTROL_ID = void 0;
const Toolbar_1 = require("../..");
exports.TOOLBAR_OTHER_ACTIONS_CONTROL_ID = 'other-actions';
const getOtherActionsControl = (items) => {
    return {
        disabled: undefined,
        id: exports.TOOLBAR_OTHER_ACTIONS_CONTROL_ID,
        type: Toolbar_1.TOOLBAR_ITEM_TYPE.group,
        items: [...items],
        text: 'Other actions'
    };
};
exports.getOtherActionsControl = getOtherActionsControl;
//# sourceMappingURL=getOtherActionsControl.js.map